import React from 'react';
import {Button, Col, Container, FormControl, FormLabel, InputGroup, Row} from 'react-bootstrap';
import {useParams} from 'react-router-dom';
import {
    offersProgressSelector,
    useGetApplicationTravelQuery,
    useGetCalculatorConfigQuery
} from '../../../features/apiSlice';
import ErrorWidget from '../../widgets/ErrorWidget';
import Card from '../../elements/ReactBootstrap/Card';
import {useSelector} from 'react-redux';
import {copyText} from '../../../utils';
import Content from '../../partials/Content.jsx';
import SmallSpinner from '../../elements/Spinner/SmallSpinner.jsx';
import OffersTableWidget from "../../widgets/Offer/OffersTableWidget.jsx";
import PremiumAmount from "../../elements/Values/PremiumAmount.jsx";

const TravelAssistanceOffer = () => {
    const {
        data: calculatorConfig,
        isSuccess: calculatorConfigIsSuccess,
    } = useGetCalculatorConfigQuery();

    const {applicationId} = useParams();

    const {
        data,
        error,
        isLoading,
        isSuccess,
        isError,
    } = useGetApplicationTravelQuery(applicationId, {
        skip: applicationId === undefined,
    });

    const progress = useSelector(offersProgressSelector(applicationId));

    return (<Content title="Оферта за нова полица ППЧ">
        <Row>
            <Col>
                {(isLoading || isSuccess) && <Card outline>
                    {isLoading && <>Търсене на предложение... <SmallSpinner /></>}
                    {isSuccess && <Container className="gx-0">
                        <Row className="row-cols-1 row-cols-sm-2 row-cols-xl-4 g-3">
                            <Col>
                                <FormLabel className="text-secondary">
                                    Мултитрип: <strong>{data.isMultiTrip ? 'Да' : 'Не'}</strong>
                                </FormLabel>
                            </Col>
                            <Col>
                                <FormLabel className="text-secondary">Период{' '}
                                    <strong>{data.periodType}{' дни'}</strong>
                                </FormLabel>
                            </Col>
                            <Col>
                                <FormLabel htmlFor="personalNumber">ЕГН/ЕИК на застраховащ</FormLabel>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <i className="fas fa-user"/>
                                    </InputGroup.Text>
                                    <FormControl type="text" id="personalNumber" disabled={true}
                                                 value={data.personalNumber} />
                                    <div className="input-group-append">
                                        <Button variant="outline-success" className="rounded-start-0"
                                                onClick={() => copyText(data.personalNumber)}>
                                            <i className="far fa-copy" />
                                        </Button>
                                    </div>
                                </InputGroup>
                            </Col>
                            <Col>
                                <FormLabel className="text-secondary">Дестинация:{' '}
                                    <strong>{calculatorConfigIsSuccess &&
                                        calculatorConfig.travelDestinations[data.destinationType]
                                    }</strong>
                                </FormLabel>
                            </Col>
                            <Col>
                                <FormLabel className="text-secondary">Цел на пътуването:{' '}
                                    <strong>{calculatorConfigIsSuccess &&
                                        calculatorConfig.travelPurposes[data.purposeType]
                                    }</strong>
                                </FormLabel>
                            </Col>
                            <Col>
                                <FormLabel className="text-secondary">Застраховани лица:{' '}
                                    {data.insuredClientPins.map(insuredClient =>
                                        <><strong>{insuredClient.insuredClientPin}</strong><br/></>
                                    )}
                                </FormLabel>
                            </Col>
                            <Col>
                                <FormLabel className="text-secondary">Медицински разноски:{' '}
                                    <strong>{data.medicalExpenses}</strong>
                                </FormLabel>
                            </Col>
                            {data.rescueCosts && <Col>
                                <FormLabel className="text-secondary">Спасителни разноски:{' '}
                                    <strong>{data.rescueCosts}</strong>
                                </FormLabel>
                            </Col>}
                            {data.deathPermanentDisability && <Col>
                                <FormLabel className="text-secondary">Смърт и трайно намалена работоспособност:{' '}
                                    <strong>{data.deathPermanentDisability}</strong>
                                </FormLabel>
                            </Col>}
                            {data.hospitalStay && <Col>
                                <FormLabel className="text-secondary">Дневни пари за болничен престой:{' '}
                                    <strong>{data.hospitalStay}</strong>
                                </FormLabel>
                            </Col>}
                            {data.personalExpenses && <Col>
                                <FormLabel className="text-secondary">Лични разходи:{' '}
                                    <strong>{data.personalExpenses}</strong>
                                </FormLabel>
                            </Col>}
                            {data.personalLuggage && <Col>
                                <FormLabel className="text-secondary">Кражба, загуба или забавяне на личен багаж:{' '}
                                    <strong>{data.personalLuggage}</strong>
                                </FormLabel>
                            </Col>}
                            {data.documentsProtection && <Col>
                                <FormLabel className="text-secondary">Разходи за откраднати/изгубени документи:{' '}
                                    <strong>{data.documentsProtection}</strong>
                                </FormLabel>
                            </Col>}
                            {data.thirdPartiesLiability && <Col>
                                <FormLabel className="text-secondary">Гражданска отговорност към трети лица:{' '}
                                    <strong>{data.thirdPartiesLiability}</strong>
                                </FormLabel>
                            </Col>}
                            {data.legalAid && <Col>
                                <FormLabel className="text-secondary">Правна помощ:{' '}
                                    <strong>{data.legalAid}</strong>
                                </FormLabel>
                            </Col>}
                            {(data.flightPackage  === true || data.onTheWayPackage  === true) && <Col>
                                <FormLabel className="text-secondary">Доnълнителни пакети - Дженерали<br/>
                                    {data.flightPackage  === true && <strong>Пакет „Полет” -
                                    <PremiumAmount amount='550' currency={'EUR'}/></strong>}
                                    {data.onTheWayPackage  === true && <strong>Пакет „На път” -
                                    <PremiumAmount amount='275' currency={'EUR'}/></strong>}
                                </FormLabel>
                            </Col>}
                        </Row>
                    </Container>}
                </Card>}
                {isError && <ErrorWidget error={error} />}
            </Col>
        </Row>
        {isSuccess && <>
            {/*<Collapse in={progress < 1}>*/}
            {/*    <Row>*/}
            {/*        <Col>*/}
            {/*            <Card>*/}
            {/*                <ProgressBar variant="success" striped animated now={progress} max={1}*/}
            {/*                             label="Търсене на най-добрите оферти..." />*/}
            {/*            </Card>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*</Collapse>*/}
            {/*<Row className="row-cols-1 row-cols-md-2 row-cols-xl-3">*/}
            {/*    {installmentCounts.map(installmentsCount => <Col key={installmentsCount}*/}
            {/*            md={installmentsCount === 1 ? 12 : null} className="d-flex">*/}
            {/*        <MtplBestOfferWidget installmentsCount={installmentsCount} />*/}
            {/*    </Col>)}*/}
            {/*</Row>*/}
            <Row>
                <Col>
                    <Card outline collapse header="Всички оферти" className="p-0">
                        <OffersTableWidget product={data.product}/>
                    </Card>
                </Col>
            </Row>
        </>}
    </Content>);
};

export default TravelAssistanceOffer;
